export default __webpack_public_path__ + "static/media/footer-img-background.239c4e4d.webp";